import React from "react";
import Doller from "../../assets/images/doller.png";

const InputPrePostFixComponent = ({
  label,
  secondLabel,
  type,
  placeholder,
  value,
  name,
  required,
  handleChange,
  postOne,
  postTwo,
  handlePostClick,
  icon,
  postType,
  disabled,
  remainingBet
}) => {
  return (
    <>
      <div className="mx-2 my-1">
        <div className="d-flex justify-content-between">
        <label
          htmlFor="website-admin"
          className=" mb-1 mb-sm-1 mb-md-1 mb-lg-1 text-sm font-medium font-semibold"
          style={{ color:'#a7a7a7'}}
        >
          {label}
        </label>
        <label
          htmlFor="website-admin"
          className=" mb-1 mb-sm-1 mb-md-1 mb-lg-1 text-sm font-medium text-white font-semibold"
        >{secondLabel}</label>
        </div>
       
        <div className="flex ">
          <div className="flex items-center relative w-full">
            <input
              type={type}
              name={name}
              id="website-admin"
              value={value}
              required={required}
              onChange={(e) => {
                handleChange(e);
              }}
              className="relative rounded form-control flex-1 min-w-0 w-full text-sm p-3/2 "
              placeholder={placeholder}
              disabled={disabled}
              style={{
                backgroundColor: "rgb(15 33 46)",
                color: "white",
                border: "1px solid rgb(47 69 83)",
              }}
            />
            {icon && (
              <span className="absolute end-1 top-1/2 transform -translate-y-1/2 text-gray-500 cursor-pointer">
                <img src={Doller} className=" w-1/2" alt="icon" />
              </span>
            )}
          </div>

          {postType == "number" && (
            <span
              className="rounded inline-flex"
              style={{ backgroundColor: "rgb(47 69 83)" }}
            >
              <span
                className={"inline-flex items-center px-2 px-md-2 px-lg-3 text-sm text-white cursor-pointer  font-semibold " + 
              (disabled ? " cursor-none ": "")}
                onClick={(e) => {
                  handlePostClick(name, value ,0.5);
                }}
                disabled={disabled}
              >
                {postOne}
              </span> |
              <span
                className={"inline-flex items-center px-2 px-md-2 px-lg-3 text-sm text-white cursor-pointer font-semibold" +
              (disabled ? " cursor-none " : "")}
                onClick={(e) => {
                  handlePostClick(name, value, 2);
                }}
                disabled={disabled}
              >
                {postTwo}
              </span>
            </span>
          )}
          {postType == "arrow" && (
            <span
              className="rounded inline-flex"
              style={{ backgroundColor: "rgb(47 69 83)" }}
            >
              <span
                className="inline-flex items-center px-2 px-md-2 px-lg-3 text-sm text-white cursor-pointer  font-semibold 
              "
                onClick={(e) => {

                  handlePostClick(name, value , "up");
                }}
              >
                <svg
                  className=" text-gray-800 dark:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 8"
                  style={{width: 12, height: 12}}
                >
                  <path
                    stroke="#FFFFFF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M13 7 7.674 1.3a.91.91 0 0 0-1.348 0L1 7"
                  />
                </svg>
               
              </span> |
              <span
                className="inline-flex items-center px-2 px-md-2 px-lg-3 text-sm text-white cursor-pointer font-semibold 
               "
                onClick={(e) => {
                  handlePostClick(name, value , "down");
                }}
              >
                 <svg
                  className=" text-gray-800 dark:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 8"
                  style={{width: 12, height: 12}}
                >
                  <path
                    stroke="#FFFFFF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 5.326 5.7a.909.909 0 0 0 1.348 0L13 1"
                  />
                </svg>
                
              </span>
            </span>
          )}
        </div>
        
        {name == "numOfBet" &&  <label
          htmlFor="website-admin"
          className=" mb-1 mb-sm-1 mb-md-1 mb-lg-1 text-sm font-medium text-white font-semibold"
        >Remaining bet: {remainingBet}</label>}
        
      </div>
    </>
  );
};

export default InputPrePostFixComponent;
